// ================================================================================
// script-vanilla.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}


	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href


	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body')

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close')
			menuOpenTarget.classList.toggle('is-menu-open')
		} )
	}


	// Floating Button
	// --------------------------------------------------------------- //

	const floatingButton = document.getElementById('js-floating-button')

	window.addEventListener('scroll', function(e) {
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let currentPos = scrollTop;

		if ( floatingButton ) {
			let siteActionPos = document.getElementById('js-site-action').getBoundingClientRect().top - window.innerHeight

			if ( siteActionPos > 0 ) {
				floatingButton.classList.remove('is-disactive')
			} else {
				floatingButton.classList.add('is-disactive')
			}
		}

	});


	// Front Page Adviser Swiper
	// --------------------------------------------------------------- //

	const swiperAdviserId = document.getElementById('adviser-swiper');

	if ( swiperAdviserId ) {

		let adviserSwiper = null;

		const checkBreakpoint = (e) => {
			if (e.matches) {
				initAdviserSwiper();
			} else if (adviserSwiper) {
				adviserSwiper.destroy(false, true);
			}
		}

		const initAdviserSwiper = () => {
			adviserSwiper = new Swiper(swiperAdviserId, {
				loop: false,
				spaceBetween: 40,
				slidesPerView: 'auto',
				grabCursor: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		};

		breakpoint.addListener(checkBreakpoint);
		checkBreakpoint(breakpoint);



	}


} );

